<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent :fullscreen="$vuetify.breakpoint.xsOnly" max-width="600px")
    v-card
      v-card-title.pa-4
        div.h6.basic800--text Merchants
      v-card-text.pa-0
        v-layout.pa-6(v-if="isFetching")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
        template(v-else)
          v-row.ma-4(v-for="(merc, i) in merchants" :key="i" no-gutters align="center")
            v-col.shrink(align="center")
              v-avatar(size="55")
                v-img(:src="merc.image ? rank.image.file : require('@/assets/image_placeholder.png')" aspect-ratio="1")
            v-col.pl-4
              div.s1.basic800--text {{ merc.name }}
              div.d-flex.align-center.mt-1(v-if="merc.earned")
                div.p2.primary400--text(v-if="merc.earned.amount") Earned {{ merc.earned.amount }}
                v-spacer
                div.p2.primary400--text(v-if="merc.earned.paid_at") {{ merc.earned.paid_at | humanizeDate }}
      v-card-actions.px-4.pb-4.pt-2
        v-btn.button-AA-small(color="info500" dark depressed small block height="32" @click="showModal = false") Done
</template>

<script>
export default {
  name: 'ShowAllMerchants',
  props: ['open', 'propAffiliate'],
  data: () => ({
    isFetching: false,
    merchants: null
  }),
  computed: {
    affiliate: {
      get() {
        return this.propAffiliate
      },
      set(newValue) {
        this.$emit('update:propAffiliate', newValue)
      }
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    this.fetchMerchants()
  },
  methods: {
    fetchMerchants () {
      this.isFetchings = true
      this.$axios.get(`/partners/stats?view=all`)
        .then(resp => {
          if (resp.data && resp.data.affiliate_merchants && resp.data.affiliate_merchants.length > 0) {
            this.merchants = resp.data.affiliate_merchants
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    }
  }
}
</script>